import { createFileRoute } from '@tanstack/react-router'
import { WebhooksList } from '@/features/webhooks/list'

export const Route = createFileRoute('/webhooks/')({
  component: WebhooksList,
})
